import { Tab, Tabs } from '@aurora/widgets-react';
import React, {
  useLayoutEffect,
  useRef,
  useState,
  useCallback,
  useEffect,
} from 'react';
import { Map } from 'react-leaflet';
import { SeaIce } from '../SeaIce';
import { Satellite } from '../Satellite';
import { useHashParams } from '../../services/hooks/useHashParam';
import { useTranslation } from 'react-i18next';
import './App.scss';

const invalidateMapSize = (
  tabIndex: number,
  iceMap: L.Map,
  satelliteMap: L.Map
) => {
  if (tabIndex === 0) iceMap.invalidateSize();
  else if (tabIndex === 1) satelliteMap.invalidateSize();
};

export const App = () => {
  const { t } = useTranslation();

  const satelliteMap = useRef<Map | null>(null);
  const iceMap = useRef<Map | null>(null);
  const { hashParams, setHashParams } = useHashParams();
  const [tabIndex, innerSetTabIndex] = useState(0);
  const setTabIndex = useCallback(
    (index) => {
      setHashParams({ view: index.toString() });
    },
    [setHashParams]
  );
  useEffect(() => {
    const num = parseInt(hashParams.view ?? '');
    if (!isNaN(num) && num >= 0 && num < 2) {
      innerSetTabIndex(num);
    }
  }, [hashParams, innerSetTabIndex]);

  // inform leaflet that it has to recalculate size when tab is changed to the corresponding map tab
  const [pollForMapRefs, setPollForMapRefs] = useState(true);
  useLayoutEffect(() => {
    const ice = iceMap.current?.leafletElement;
    const sat = satelliteMap.current?.leafletElement;
    if (!ice || !sat) return;
    invalidateMapSize(tabIndex, ice, sat);
  }, [tabIndex, pollForMapRefs]);

  useEffect(() => {
    if (!pollForMapRefs) return;
    const ice = iceMap.current?.leafletElement;
    const sat = satelliteMap.current?.leafletElement;
    if (ice && sat) setPollForMapRefs(false);
  }, [tabIndex, pollForMapRefs]);

  return (
    <>
      <Tabs value={tabIndex} onChange={setTabIndex}>
        <Tab label={t('seaIceMap')}>
          <SeaIce mapRef={iceMap} />
        </Tab>
        <Tab label={t('satellite')}>
          <Satellite mapRef={satelliteMap} />
        </Tab>
      </Tabs>
    </>
  );
};
